<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs >
        <a-tab-pane key="1" tab="积分概况">
          <SmallSquare class='m-b-20' content="1、积分概况数据统一为零点更新，不包括当日数据。所有用户当前持有的有效积分总和＝发放概况的“全部时间”积分总计－消耗概况的“全部时间”积分总计。
2、积分消耗概况仅统计会员端的消耗（积分兑换和参与活动），所以会出现积分消耗概况的数据与积分总概况的数据不一致的情况。" />
          <integralGeneral />
        </a-tab-pane>
        <a-tab-pane key="2" tab="积分明细">
          <SmallSquare class='m-b-20' content="积分明细数据为实时数据，包括客户的积分获得明细和消耗明细。" />
          <integralDetail />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>

<script>
  import integralGeneral from './components/integralGeneral'
  import integralDetail from './components/integralDetail'
  export default {
    components: { integralGeneral, integralDetail }
  }
</script>